<template>
    <div>
        <main>
            <div class="tw-container">
                <div class="tw-flex tw-flex-col lg:tw-flex-row">
                    <img src="~@/assets/img/store_baloon.svg" alt="Store" class="baloon">
                    <div class="tw-flex-1 tw-flex tw-flex-col tw-items-center lg:tw-items-start lg:tw-ml-32">
                        <h2>Click <img src="~@/assets/img/symbol.svg" alt="and"> Collect</h2>
                        <h1>Commandez en ligne et retirez votre achats dans votre magasin</h1>
                        <div class="tw-flex tw-flex-col lg:tw-flex-row ">
                            <h3>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="26.433" viewBox="0 0 24 26.433"><g id="Icon_feather-lock" data-name="Icon feather-lock" transform="translate(-3.95 -5.398)"><path id="Path_5263" data-name="Path 5263" d="M6.933,16.5H23.967A2.433,2.433,0,0,1,26.4,18.933V27.45a2.433,2.433,0,0,1-2.433,2.433H6.933A2.433,2.433,0,0,1,4.5,27.45V18.933A2.433,2.433,0,0,1,6.933,16.5Z" transform="translate(0.5 0.898)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.1"/><path id="Path_5264" data-name="Path 5264" d="M10.5,13.95V9.083C10.5,5.724,12.94,3,15.95,3S21.4,5.724,21.4,9.083V13.95" transform="translate(-0.5 3.448)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.1"/></g></svg>
                                Sécurisé
                            </h3>
                            <h3 class="lg:tw-ml-24">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="28.394" viewBox="0 0 24 28.394"><path id="_001-stopwatch" data-name="001-stopwatch" d="M21.233,8.728l1.113-1.113a1.108,1.108,0,0,0-1.566-1.566L19.666,7.161a11.886,11.886,0,0,0-6.558-2.717V2.215h1.071a1.108,1.108,0,0,0,0-2.215H9.821a1.108,1.108,0,0,0,0,2.215h1.071V4.445a12,12,0,1,0,10.34,4.283ZM12,26.178a9.785,9.785,0,1,1,9.785-9.785A9.8,9.8,0,0,1,12,26.178Zm5.133-14.918a1.108,1.108,0,0,1,0,1.566l-4.35,4.35a1.108,1.108,0,0,1-1.566-1.566l4.35-4.35A1.108,1.108,0,0,1,17.133,11.261Zm0,0" fill="#fff"/></svg>
                                Retrait 2 heures
                            </h3>
                        </div>
                        <button type="button" class="btn-cta btn-cta-black" @click="scrollTo('.map')">
                            Trouvez votre magasin
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="26.444" viewBox="0 0 22 26.444"><g id="pin" transform="translate(-3.5 -0.5)"><path id="Path_530" data-name="Path 530" d="M24.5,11.5c0,7.778-10,14.444-10,14.444S4.5,19.278,4.5,11.5a10,10,0,1,1,20,0Z" transform="translate(0 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><path id="Path_531" data-name="Path 531" d="M20.167,13.833A3.333,3.333,0,1,1,16.833,10.5,3.333,3.333,0,0,1,20.167,13.833Z" transform="translate(-2.333 -2.333)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg>
                        </button>
                    </div>
                </div>
                <div class="steps tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-mt-10 lg:tw-mt-20 tw-text-center tw-gap-8 lg:tw-gap-20">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="90.674" height="96.654" viewBox="0 0 90.674 96.654"><g id="Group_1893" data-name="Group 1893" transform="translate(-72.195)"><path id="_002-shopping" data-name="002-shopping" d="M136.929,99.565V23.6a7.605,7.605,0,0,0-7.6-7.6H71.6A7.605,7.605,0,0,0,64,23.6V99.565a7.605,7.605,0,0,0,7.6,7.6h57.736a7.605,7.605,0,0,0,7.6-7.6ZM71.6,19.039h57.736a4.565,4.565,0,0,1,4.3,3.039H67.3a4.565,4.565,0,0,1,4.3-3.039Zm-4.558,6.077h66.852V98.045H67.039Zm.261,75.968h66.329a4.565,4.565,0,0,1-4.3,3.039H71.6A4.565,4.565,0,0,1,67.3,101.084Zm48.988-16.713,1.964-1.964a1.519,1.519,0,0,0-1.074-2.594h-1.519a6.084,6.084,0,0,0-6.077-6.077H91.348a6.077,6.077,0,0,0,0,12.155h13.674v6.077a1.519,1.519,0,0,0,2.594,1.074l1.964-1.965,3.484,3.484a1.519,1.519,0,0,0,2.149,0L119.771,90a1.519,1.519,0,0,0,0-2.149Zm-9.746-4.558a1.519,1.519,0,0,0-1.519,1.519v1.519H91.348a3.039,3.039,0,0,1,0-6.077h18.232a3.042,3.042,0,0,1,3.039,3.039Zm7.6,11.526-3.484-3.484a1.519,1.519,0,0,0-2.149,0l-.445.445V82.852h5.448l-.445.445a1.519,1.519,0,0,0,0,2.149l3.484,3.484Zm7.6-57.106h-4.558a1.519,1.519,0,0,0-1.474,1.151l-1.232,4.927h-29.2a1.519,1.519,0,0,0-1.49,1.817L86.82,57.321a1.519,1.519,0,0,0,1.49,1.221h24.31a1.519,1.519,0,0,1,0,3.039H88.31a4.56,4.56,0,1,0,4.3,3.039h12.678a4.558,4.558,0,1,0,8.533-.161,4.558,4.558,0,0,0,.584-8.593l2.741-13.7,1.223-4.891h3.372a1.519,1.519,0,1,0,0-3.039Zm-33.7,13.674-.912-4.558h4.368l.456,4.558Zm1.519,7.6-.912-4.558h3.608l.456,4.558Zm9.39,0H95.762l-.456-4.558h3.639Zm0-7.6H95l-.456-4.558h4.4Zm6.222,7.6h-3.183V50.945h3.639Zm.76-7.6h-3.943V43.348h4.4Zm5.447,7.6h-3.153l.456-4.558h3.608Zm1.519-7.6h-3.912l.456-4.558H113.8ZM88.31,67.658a1.519,1.519,0,1,1,1.519-1.519A1.519,1.519,0,0,1,88.31,67.658Zm21.271,0a1.519,1.519,0,1,1,1.519-1.519A1.519,1.519,0,0,1,109.581,67.658ZM76.155,29.674a1.519,1.519,0,0,1-1.519,1.519H71.6a1.519,1.519,0,0,1,0-3.039h3.039A1.519,1.519,0,0,1,76.155,29.674Zm16.713,1.519H80.713a1.519,1.519,0,0,1,0-3.039H92.868a1.519,1.519,0,0,1,0,3.039Zm37.984-1.519a1.519,1.519,0,1,1-1.519-1.519A1.519,1.519,0,0,1,130.852,29.674Zm-6.077,0a1.519,1.519,0,1,1-1.519-1.519A1.519,1.519,0,0,1,124.774,29.674Zm-9.116,0a1.519,1.519,0,1,1,1.519,1.519A1.519,1.519,0,0,1,115.658,29.674Z" transform="translate(25.94 -16)" fill="#fff"/><g id="_1" data-name="1" transform="translate(72.195 66.774)"><circle id="Ellipse_41" data-name="Ellipse 41" cx="15.007" cy="15.007" r="15.007" transform="translate(0 -0.133)" fill="#231f20"/><path id="Path_5272" data-name="Path 5272" d="M5.562-12.6V0H2.646V-10.26H.126V-12.6Z" transform="translate(11.356 20.866)" fill="#fff"/></g></g></svg>
                        <h4>Commandez en ligne vos produits favoris</h4>
                        <p>Retrouvez l’ensemble de nos produits sur le site de votre magasin, ajoutez les à votre panier et payez en ligne en toute sécurité</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="103.845" height="93.914" viewBox="0 0 103.845 93.914"><g id="Group_1894" data-name="Group 1894" transform="translate(-67.328 0)"><path id="_003-event" data-name="003-event" d="M97.05,21.895H88.209V20.421a4.421,4.421,0,0,0-8.842,0v1.474H64.63V20.421a4.421,4.421,0,0,0-8.842,0v1.474H41.052V20.421a4.421,4.421,0,1,0-8.842,0v1.474H23.368A7.377,7.377,0,0,0,16,29.263V97.05a7.377,7.377,0,0,0,7.368,7.368H97.05a7.377,7.377,0,0,0,7.368-7.368V29.263A7.376,7.376,0,0,0,97.05,21.895ZM82.314,20.421a1.474,1.474,0,1,1,2.947,0v8.842a1.474,1.474,0,0,1-2.947,0Zm-23.578,0a1.474,1.474,0,0,1,2.947,0v8.842a1.474,1.474,0,0,1-2.947,0Zm-23.578,0a1.474,1.474,0,1,1,2.947,0v8.842a1.474,1.474,0,0,1-2.947,0ZM23.368,24.842H32.21v4.421a4.421,4.421,0,1,0,8.842,0V24.842H55.788v4.421a4.421,4.421,0,0,0,8.842,0V24.842H79.367v4.421a4.421,4.421,0,0,0,8.842,0V24.842H97.05a4.426,4.426,0,0,1,4.421,4.421V39.578H18.947V29.263A4.426,4.426,0,0,1,23.368,24.842ZM97.05,101.471H23.368a4.426,4.426,0,0,1-4.421-4.421V42.526h82.524V97.05a4.426,4.426,0,0,1-4.421,4.421ZM94.1,52.841H88.209a1.474,1.474,0,0,0-1.474,1.474v5.895a1.474,1.474,0,0,0,1.474,1.474H94.1a1.474,1.474,0,0,0,1.474-1.474V54.315A1.474,1.474,0,0,0,94.1,52.841Zm-1.474,5.895H89.682V55.788h2.947Zm-28,23.578H58.736a1.474,1.474,0,0,0-1.474,1.474v5.895a1.474,1.474,0,0,0,1.474,1.474H64.63A1.474,1.474,0,0,0,66.1,89.682V83.788A1.474,1.474,0,0,0,64.63,82.314Zm-1.474,5.895H60.209V85.261h2.947ZM49.894,52.841H44a1.474,1.474,0,0,0-1.474,1.474v5.895A1.474,1.474,0,0,0,44,61.683h5.895a1.474,1.474,0,0,0,1.474-1.474V54.315A1.474,1.474,0,0,0,49.894,52.841ZM48.42,58.736H45.473V55.788H48.42ZM35.157,67.578H29.263a1.474,1.474,0,0,0-1.474,1.474v5.895a1.474,1.474,0,0,0,1.474,1.474h5.895a1.474,1.474,0,0,0,1.474-1.474V69.051A1.474,1.474,0,0,0,35.157,67.578Zm-1.474,5.895H30.736V70.525h2.947Zm16.21-5.895H44a1.474,1.474,0,0,0-1.474,1.474v5.895A1.474,1.474,0,0,0,44,76.419h5.895a1.474,1.474,0,0,0,1.474-1.474V69.051A1.474,1.474,0,0,0,49.894,67.578ZM48.42,73.472H45.473V70.525H48.42ZM35.157,82.314H29.263a1.474,1.474,0,0,0-1.474,1.474v5.895a1.474,1.474,0,0,0,1.474,1.474h5.895a1.474,1.474,0,0,0,1.474-1.474V83.788A1.474,1.474,0,0,0,35.157,82.314Zm-1.474,5.895H30.736V85.261h2.947Zm16.21-5.895H44a1.474,1.474,0,0,0-1.474,1.474v5.895A1.474,1.474,0,0,0,44,91.156h5.895a1.474,1.474,0,0,0,1.474-1.474V83.788A1.474,1.474,0,0,0,49.894,82.314ZM48.42,88.209H45.473V85.261H48.42ZM81.063,58.917l-7.368-1.126-3.309-7.05a1.474,1.474,0,0,0-2.668,0l-3.308,7.05-7.368,1.126a1.474,1.474,0,0,0-.832,2.487l5.375,5.509-1.271,7.8a1.474,1.474,0,0,0,2.165,1.526L69.051,72.6l6.573,3.633a1.474,1.474,0,0,0,2.167-1.527l-1.271-7.8L81.9,61.4a1.474,1.474,0,0,0-.832-2.487Zm-7.172,6.469a1.474,1.474,0,0,0-.4,1.266l.9,5.536-4.63-2.56a1.474,1.474,0,0,0-1.426,0l-4.63,2.56.9-5.536a1.474,1.474,0,0,0-.4-1.266L60.32,61.4l5.311-.811a1.474,1.474,0,0,0,1.111-.831l2.309-4.92,2.309,4.919a1.474,1.474,0,0,0,1.111.831l5.311.811ZM94.1,67.578H88.209a1.474,1.474,0,0,0-1.474,1.474v5.895a1.474,1.474,0,0,0,1.474,1.474H94.1a1.474,1.474,0,0,0,1.474-1.474V69.051A1.474,1.474,0,0,0,94.1,67.578Zm-1.474,5.895H89.682V70.525h2.947ZM94.1,82.314H88.209a1.474,1.474,0,0,0-1.474,1.474v5.895a1.474,1.474,0,0,0,1.474,1.474H94.1a1.474,1.474,0,0,0,1.474-1.474V83.788A1.474,1.474,0,0,0,94.1,82.314Zm-1.474,5.895H89.682V85.261h2.947ZM79.367,82.314H73.472A1.474,1.474,0,0,0,72,83.788v5.895a1.474,1.474,0,0,0,1.474,1.474h5.895a1.474,1.474,0,0,0,1.474-1.474V83.788A1.474,1.474,0,0,0,79.367,82.314Zm-1.474,5.895H74.946V85.261h2.947Z" transform="translate(66.754 -16)" fill="#fff"/><circle id="Ellipse_41" data-name="Ellipse 41" cx="15.007" cy="15.007" r="15.007" transform="translate(67.328 63.9)" fill="#231f20"/><path id="Path_5273" data-name="Path 5273" d="M10.116-2.376V0H.594V-1.89l4.86-4.59A5.161,5.161,0,0,0,6.5-7.749,2.308,2.308,0,0,0,6.768-8.8a1.392,1.392,0,0,0-.513-1.161,2.387,2.387,0,0,0-1.5-.4,3.451,3.451,0,0,0-1.494.315,2.861,2.861,0,0,0-1.116.945L.018-10.476a4.983,4.983,0,0,1,2.034-1.719,6.793,6.793,0,0,1,2.97-.621,6.106,6.106,0,0,1,2.457.459,3.787,3.787,0,0,1,1.638,1.3A3.353,3.353,0,0,1,9.7-9.09,4.394,4.394,0,0,1,9.27-7.164,7.414,7.414,0,0,1,7.6-5.112L4.7-2.376Z" transform="translate(77.062 84.9)" fill="#fff"/></g></svg>
                        <h4>Choisissez la date et l’heure de votre retrait</h4>
                        <p>Une fois votre commande terminée, choisissez la date et l’heure de votre retrait pour plus de sécurité en magasin.</p>
                    </div>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="101.467" height="96.654" viewBox="0 0 101.467 96.654"><g id="Group_1895" data-name="Group 1895" transform="translate(-69.761 0)"><path id="_001-address" data-name="001-address" d="M111.962,59.447l-7.436-14.873v-2.68a4.563,4.563,0,0,0-4.558-4.558H79.441a13.674,13.674,0,1,0-22.76,0H36.155A4.563,4.563,0,0,0,31.6,41.894v2.68L24.16,59.447a1.514,1.514,0,0,0-.158.68h0v3.039a7.59,7.59,0,0,0,3.044,6.077h0v36.465a1.519,1.519,0,0,0,1.519,1.519h79.007a1.519,1.519,0,0,0,1.519-1.519V69.242h-.005a7.59,7.59,0,0,0,3.044-6.077V60.126h0A1.515,1.515,0,0,0,111.962,59.447ZM99.968,40.375a1.521,1.521,0,0,1,1.519,1.519v1.519H75.1l1.5-3,.052-.043ZM68.061,19.1a10.636,10.636,0,0,1,6.418,19.115,1.521,1.521,0,0,0-.44.529L68.061,50.661,62.083,38.748a1.519,1.519,0,0,0-.44-.529A10.636,10.636,0,0,1,68.061,19.1ZM34.636,41.894a1.521,1.521,0,0,1,1.519-1.519H59.469l.052.043,1.5,3H34.636Zm-.58,4.558H62.55L66.7,54.73a1.519,1.519,0,0,0,2.716,0l4.154-8.278h28.494l6.077,12.155H27.978ZM96.929,61.646v1.519a4.558,4.558,0,0,1-9.116,0V61.646Zm-12.155,0v1.519a4.558,4.558,0,0,1-9.116,0V61.646Zm-12.155,0v1.519a4.558,4.558,0,0,1-9.116,0V61.646Zm-12.155,0v1.519a4.558,4.558,0,0,1-9.116,0V61.646Zm-12.155,0v1.519a4.558,4.558,0,0,1-9.116,0V61.646ZM27.039,63.165V61.646h9.116v1.519a4.558,4.558,0,0,1-9.116,0Zm48.619,41.023H60.465V76.839H75.658Zm30.387,0H78.7V75.32A1.519,1.519,0,0,0,77.178,73.8H58.945a1.519,1.519,0,0,0-1.519,1.519v28.868H30.077V70.61a7.6,7.6,0,0,0,7.6-2.891,7.589,7.589,0,0,0,12.155,0,7.589,7.589,0,0,0,12.155,0,7.589,7.589,0,0,0,12.155,0,7.589,7.589,0,0,0,12.155,0,7.589,7.589,0,0,0,12.155,0,7.6,7.6,0,0,0,7.6,2.891Zm3.039-41.023a4.558,4.558,0,0,1-9.116,0V61.646h9.116ZM68.061,35.817a6.077,6.077,0,1,0-6.077-6.077A6.077,6.077,0,0,0,68.061,35.817Zm0-9.116a3.039,3.039,0,1,1-3.039,3.039A3.039,3.039,0,0,1,68.061,26.7Zm4.558,66.852A1.519,1.519,0,1,1,71.1,92.033,1.519,1.519,0,0,1,72.619,93.552Zm-7.6-4.558H71.1a1.519,1.519,0,0,0,1.519-1.519V81.4A1.519,1.519,0,0,0,71.1,79.878H65.023A1.519,1.519,0,0,0,63.5,81.4v6.077A1.519,1.519,0,0,0,65.023,88.994Zm1.519-6.077h3.039v3.039H66.542ZM52.868,76.839H34.636a1.519,1.519,0,0,0-1.519,1.519V99.63a1.519,1.519,0,0,0,1.519,1.519H52.868a1.519,1.519,0,0,0,1.519-1.519V78.359A1.519,1.519,0,0,0,52.868,76.839ZM51.348,98.11H36.155V79.878H51.348Zm50.139-21.271H83.255a1.519,1.519,0,0,0-1.519,1.519V99.63a1.519,1.519,0,0,0,1.519,1.519h18.232a1.519,1.519,0,0,0,1.519-1.519V78.359A1.519,1.519,0,0,0,101.487,76.839ZM99.968,98.11H84.774V79.878H99.968Zm-60.329-5a1.519,1.519,0,0,1,0-2.149l6.077-6.077a1.519,1.519,0,1,1,2.149,2.149l-6.077,6.077a1.519,1.519,0,0,1-2.149,0Zm48.619,0a1.519,1.519,0,0,1,0-2.149l6.077-6.077a1.519,1.519,0,1,1,2.149,2.149l-6.077,6.077A1.519,1.519,0,0,1,88.258,93.107Z" transform="translate(59.105 -16.08)" fill="#fff"/><g id="_3" data-name="3" transform="translate(69.761 66.774)"><circle id="Ellipse_41" data-name="Ellipse 41" cx="15.007" cy="15.007" r="15.007" transform="translate(0 -0.134)" fill="#231f20"/><path id="Path_5274" data-name="Path 5274" d="M6.588-7.47A4.241,4.241,0,0,1,9.126-6.237a3.4,3.4,0,0,1,.882,2.385,3.764,3.764,0,0,1-.576,2.025A4.012,4.012,0,0,1,7.677-.342,6.723,6.723,0,0,1,4.788.216,9.91,9.91,0,0,1,2.169-.135a6.746,6.746,0,0,1-2.187-1L1.116-3.366a5.494,5.494,0,0,0,1.665.837,6.417,6.417,0,0,0,1.935.3,3.067,3.067,0,0,0,1.728-.423,1.359,1.359,0,0,0,.63-1.2Q7.074-5.4,4.716-5.4H3.384V-7.326L5.976-10.26H.612V-12.6h8.82v1.89Z" transform="translate(9.734 20.867)" fill="#fff"/></g></g></svg>
                        <h4>Retirez en magasin et gagnez du temps</h4>
                        <p>En faisant le retrait en magasin, vous pouvez en quelques heures récupérer vos produits de création préférés.</p>
                    </div>
                </div>
            </div>
        </main>
        <section class="map">
            <h3>Trouvez votre magasin</h3>
            <div class="lg:tw-container">
                <MapContainer />
            </div>
        </section>
        <section class="pre-footer">
            <div class="tw-container tw-flex tw-flex-col lg:tw-flex-row tw-items-center">
                <img src="~@/assets/img/logo_secondary.svg" alt="Rougier & Plé">
                <p class="tw-flex-1 lg:tw-ml-16" v-html="footerText"></p>
            </div>
        </section>
        <footer class="tw-flex tw-items-center tw-justify-center">
            <img src="~@/assets/img/logo.svg" alt="Rougier & Plé">
        </footer>
    </div>
</template>

<script>
import MapContainer from '@/components/MapContainer.vue';
import axios from 'axios';

export default {
    data() {
        return {
            footerText: '',
        };
    },
    components: {
        MapContainer,
    },
    methods: {
        scrollTo(target) {
            document.querySelector(`${target}`).scrollIntoView({
                behavior: 'smooth',
            });
        },
    },
    mounted() {
        axios
            .get('./footer-text.txt')
            .then((response) => {
                this.footerText = response.data;
            })
            .catch((err) => {
                console.log(err.response.status);
                console.log(err.response.statusText);
                this.footerText = 'La créativité est notre raison d’être, et pour vous accompagner au quotidien dans vos créations, plusieurs magasins <strong>Rougier&Plé</strong> vous proposent leurs produits en retrait en magasin. Nous aurions pu l’appeler <strong>drive ou click and collect</strong> mais avec une histoire française de plus de 165 ans, nous nous sommes dit que retrait en magasin correspondait plus à <strong>Rougier&Plé</strong>. Faire ses courses en ligne et profiter du retrait en magasin est un gain de temps. Votre satisfaction et la qualité étant notre priorité, le retrait se fera sans contact en toute sécurité.';
            });
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';

main {
    padding: 40px 0;
    background-color: $main_color;
    color: #fff;

    @screen lg {
        padding: 65px 0;
    }

    .baloon {
        display: block;
        margin: 0 auto;
        margin-bottom: 10px;
        max-width: 105px;
        width: 100%;
        height: auto;

        @screen lg {
            max-width: 280px;
        }
    }
    h2 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        font-weight: 900;
        font-size: 39px;

        @screen lg {
            margin-bottom: 20px;
            font-size: 66px;
        }

        img {
            display: inline;
            margin: 0 6px;
            width: auto;
            height: 29px;

            @screen lg {
                margin: 0 20px;
                height: 50px;
            }
        }
    }
    h1 {
        margin-bottom: 25px;
        text-align: center;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;

        @screen lg {
            margin-bottom: 35px;
            text-align: left;
            font-size: 28px;
            line-height: 36px;
        }
    }
    h3 {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 16px;
        line-height: 1;

        @screen lg {
            margin-bottom: 45px;
            font-size: 22px;
        }
        svg {
            margin-right: 15px;
            width: auto;
            height: 25px;

            @screen lg {
                margin-right: 20px;
                height: 30px;
            }
        }
    }
    .steps {
        svg {
            display: block;
            margin-right: auto;
            margin-bottom: 20px;
            margin-left: auto;
            height: 95px;
        }
        h4 {
            margin-right: auto;
            margin-bottom: 10px;
            margin-left: auto;
            max-width: 290px;
            font-weight: 700;
            font-size: 18px;
            line-height: 22px;

            @screen lg {
                max-width: 100%;
                font-size: 20px;
                line-height: 24px;
            }
        }
        p {
            margin-right: auto;
            margin-left: auto;
            max-width: 290px;
            color: #ebdedf;
            font-size: 14px;
            line-height: 18px;

            @screen lg {
                max-width: 100%;
            }
        }
    }
}
section.map {
    padding: 45px 0 0 0;

    @screen lg {
        padding: 70px 0;
    }
    h3 {
        margin-bottom: 20px;
        text-align: center;
        font-weight: 700;
        font-size: 26px;
        @screen lg {
            margin-bottom: 35px;
            font-size: 32px;
        }
    }
    .map-container {
        @screen lg {
            height: 730px;
        }
    }
}
section.pre-footer {
    padding: 50px 0;
    background-color: $light_gray;

    img {
        max-width: 145px;
        width: 100%;
    }
    p {
        margin-top: 25px;
        color: $text_gray;
        font-size: 15px;
        line-height: 21px;

        @screen lg {
            margin-top: 0;
            font-size: 17px;
            line-height: 24px;
        }
    }
}
footer {
    padding: 20px 0;
    background-color: $medium_gray;

    img {
        max-width: 150px;
        width: 100%;
        filter: brightness(0) invert(1);
    }
}

</style>
